var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDrone = function SvgDrone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.927 10.004h4.01m-4.01 0v4m0-4-3.508-3.5m7.517 3.5v4m0-4 3.508-3.5m-3.508 7.5H9.927m4.01 0 3.507 3.5m-7.517-3.5-3.508 3.5m3.468-11.5a3.5 3.5 0 0 0-2.363-2.825 3.52 3.52 0 0 0-3.59.845 3.5 3.5 0 0 0-.848 3.582 3.5 3.5 0 0 0 2.832 2.358m12.027 0a3.51 3.51 0 0 0 2.832-2.358 3.49 3.49 0 0 0-.847-3.582 3.51 3.51 0 0 0-3.59-.845 3.51 3.51 0 0 0-2.364 2.825m0 12a3.5 3.5 0 0 0 2.364 2.825 3.52 3.52 0 0 0 3.59-.846 3.5 3.5 0 0 0 .847-3.581 3.5 3.5 0 0 0-2.832-2.358m-12.027 0a3.51 3.51 0 0 0-2.832 2.358 3.49 3.49 0 0 0 .848 3.581 3.51 3.51 0 0 0 5.953-1.98"
  })));
};
export default SvgDrone;